import { Select } from '@mantine/core';
import type { Editor } from '@tiptap/react';
import { useLoadDebtorFiles } from 'app/Private/ExternalMailbox/NewMail/use-load-debtor-files';
import { i18nKeys, useTranslation } from 'locales';
import type { RefObject } from 'react';
import { useState } from 'react';

type DebtorFileInsertProps = {
  debtorId: string;
  editorRef: RefObject<Editor | null>;
};

export const DebtorFileInsert = ({ debtorId, editorRef }: DebtorFileInsertProps) => {
  const { t } = useTranslation();
  const { debtorFiles } = useLoadDebtorFiles(debtorId, { enabled: true });

  const [value, setValue] = useState<string | null>(null);

  const data = [
    {
      group: t(i18nKeys.EXTERNAL_MAIL.FILE_TYPE.CLIENT_PORTAL),
      items: debtorFiles.files
        .filter(f => f.type === 'clientPortal')
        .map(f => ({ value: f.link, label: f.filename })),
    },
    {
      group: t(i18nKeys.EXTERNAL_MAIL.FILE_TYPE.INVOICE),
      items: debtorFiles.files
        .filter(f => f.type === 'invoice')
        .map(f => ({ value: f.link, label: f.filename })),
    },
    {
      group: t(i18nKeys.EXTERNAL_MAIL.FILE_TYPE.CREDIT_NOTE),
      items: debtorFiles.files
        .filter(f => f.type === 'creditNote')
        .map(f => ({ value: f.link, label: f.filename })),
    },
    {
      group: t(i18nKeys.EXTERNAL_MAIL.FILE_TYPE.TERMS_AND_CONDITIONS),
      items: debtorFiles.files
        .filter(f => f.type === 'termsAndConditions')
        .map(f => ({ value: f.link, label: f.filename })),
    },
  ];

  return (
    <Select
      size="xs"
      placeholder={t(i18nKeys.EXTERNAL_MAIL.INSERT_DEBTOR_FILE)}
      searchable
      clearable
      data={data}
      value={value}
      onChange={(link, option) => {
        if (!link) return;
        editorRef.current
          ?.chain()
          .focus()
          .insertContent(`<a href="${link}">${option.label}</a>`)
          .run();
        setValue(null);
      }}
    />
  );
};
